import React, { useState, useEffect, useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import { setAttributionIsVisible } from "core/AssetDownload/Context/actions";

// Photo Download Hook
import usePhotoDownload from "frontend/hooks/usePhotoDownload";

import Button from "core/Button";

/* we're using an arbritrary amount of time to delay
the actual download in order to show the user the download
button's processing state, which gives them a visual cue
of what's happening after they click the download button */
const DOWNLOAD_DELAY_IN_MS = 3000;

const getDownloadType = (asset, purchaseType) => {
    if (
        asset.license === "PUBLICDOMAIN" ||
        purchaseType.downloadType === "FREE"
    ) {
        return "FREE";
    }
    if (asset.isPremium === true) {
        return "PREMIUM_PHOTO";
    }
    return "STANDARD_PHOTO";
};

const DownloadPhotoButton = () => {
    const { state, dispatch } = useContext(AssetDownloadContext);
    const { asset, purchaseType, assetDownloadConfig } = state;

    const { purchaseTypeKeys } = assetDownloadConfig;

    const { startDownload, isStarted, isComplete } = usePhotoDownload({
        downloadType: getDownloadType(asset, purchaseType),
        photoId: asset.id
    });

    const [delayingDownload, setDelayingDownload] = useState(false);

    useEffect(() => {
        if (isStarted && !isComplete) {
            setDelayingDownload(true);
            setTimeout(() => setDelayingDownload(false), DOWNLOAD_DELAY_IN_MS);
        }
    }, [isStarted, isComplete]);

    const onClick = () => {
        startDownload();
        if (purchaseType.key === purchaseTypeKeys.basic) {
            dispatch(setAttributionIsVisible(true));
        }
    };

    /* We want to disable the button and show feedback for no less
    than DOWNLOAD_DELAY_IN_MS time, or until the download is
    finished - whichever occurs last. */
    const downloadInProgress = (isStarted && !isComplete) || delayingDownload;
    return (
        <Button
            styleType="cta"
            onClick={onClick}
            isDisabled={downloadInProgress}
            isProcessing={downloadInProgress}
            width="100%"
            darkMode
        >
            {downloadInProgress ? "Processing" : "Download JPG"}
        </Button>
    );
};

export default DownloadPhotoButton;
